import { AdbScrcpyOptions2_0 } from "./2_0.js";

export class AdbScrcpyOptionsLatest extends AdbScrcpyOptions2_0 {}
